var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallAccept(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 92"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.69,43.68A29.08,29.08,0,0,0,48.32,56.31l4.22-4.21a1.89,1.89,0,0,1,2-.47,21.87,21.87,0,0,0,6.84,1.1,1.92,1.92,0,0,1,1.92,1.91v6.69a1.92,1.92,0,0,1-1.92,1.92A32.58,32.58,0,0,1,28.75,30.67a1.92,1.92,0,0,1,1.92-1.92h6.71a1.92,1.92,0,0,1,1.91,1.92,21.78,21.78,0,0,0,1.09,6.84,1.89,1.89,0,0,1-.48,2Z"
  })));
}

export default SvgCallAccept;